import { AssetUrlPipe } from "../../../core/pipes/asset-url.pipe";
import { CommonModule } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { LoadingComponent } from "../../../components/common/loading/loading.component";
import { TabComponent } from "../../../components/common/tab/tab.component";
import { FormModalComponent } from "../../../components/modal-templates/form-modal/form-modal.component";
import { addReturnTypeFields } from "../../../core/generic-templates/dynamic-form-template";
import { Tabs } from "../../../core/models/tab-field";
import { MessageEnum } from "../../../core/utils/message.enum";
import { BaseLayoutComponent } from "../../base-layout.component";
import { ParameterTabComponent } from "./parameter-tab/parameter-tab.component";

@Component({
  selector: "app-rest-service-operations-view",
  standalone: true,
  imports: [AssetUrlPipe, CommonModule, FormsModule, TabComponent, LoadingComponent],
  templateUrl: "./rest-service-operations-view.component.html",
  styleUrl: "./rest-service-operations-view.component.scss",
})
export class RestServiceOperationsViewComponent   extends BaseLayoutComponent implements OnInit {
  private modalService = inject(NgbModal);
  isLoading: boolean = false;
  projectId: string = "";
  automationProjectId: string = "";
  serviceId: string = "";
  operationId: string = "";
  operationData: any;
  tabs: Tabs[] = [
    {
      label: "Parameters",
      component: ParameterTabComponent,
      view: "parameter",
      disabled: false,
    },
    {
      label: "Headers",
      component: ParameterTabComponent,
      view: "header",
      disabled: false,
    },
  ];
  isEdit: boolean = false;
  returnTypeObject: any;
  schemasList: any;
  modalRef: any;
  dataModel:any;


  ngOnInit(): void {
    this.projectService.getProjectId().subscribe((id: any) => {
      this.projectId = id;
    });

    this.projectService.getAutomationProjectId().subscribe((id: any) => {
      this.automationProjectId = id;
    });

    this.projectService.getServiceId().subscribe((id: any) => {
      this.serviceId = id;
    });
    this.projectService.getOperationId().subscribe((id: any) => {
      this.operationId = id;
    });

    this.automatiCScriptService.getActiveNode().subscribe((item) => {
      this.operationData = item;
      // console.log()
    });
    // this.getOperation();
    // this.getSchemas();
  }

  // saveOperation() {}

  getSchemas() {
    const schemIdIndex = addReturnTypeFields.findIndex(
      (f) => f.key === "schemaId"
    );
    const schemIdComIndex = addReturnTypeFields.findIndex(
      (f) => f.key === "schemaIdCom"
    );
    addReturnTypeFields[schemIdIndex].isLoading = true;
    addReturnTypeFields[schemIdComIndex].isLoading = true;
    this.modalRef.componentInstance.fields = addReturnTypeFields;

    this.restService
      .getAutomationSchema(this.projectId, this.automationProjectId)
      .subscribe({
        next: (item) => {
          //re assign the data once schema loaded
          addReturnTypeFields[schemIdIndex].isLoading = false;
          addReturnTypeFields[schemIdComIndex].isLoading = false;
          this.schemasList = item?.data?.map((obj: any) => ({
            label: obj.name,
            value: obj.id,
          }));

          addReturnTypeFields[4].options = this.schemasList;
          addReturnTypeFields[5].options = this.schemasList;
          this.dataModel.schemaId = this.returnTypeObject?.schemaId
          ? this.returnTypeObject?.schemaId
          : this.operationData?.schemaId,
          this.dataModel.schemaIdCom= this.returnTypeObject?.schemaId
          ? this.returnTypeObject?.schemaId
          : this.operationData?.schemaId,

          this.modalRef.componentInstance.fields = addReturnTypeFields;
          this.modalRef.componentInstance.model = this.isEdit ? this.dataModel : {};

         
        },
        error: (error) => {
          addReturnTypeFields[schemIdIndex].isLoading = false;
          addReturnTypeFields[schemIdComIndex].isLoading = false;
          this.modalRef.componentInstance.fields = addReturnTypeFields;

          console.error("Error fetching schemas:", error);
        },
      });
  }

  selectReturnType() {
    this.isEdit = this.determineEditMode();
    this.dataModel = this.isEdit ? this.buildDataModel() : {};

    this.openReturnTypeModal();
  }

  private determineEditMode(): boolean {
    return !!(this.operationData?.acceptType || this.returnTypeObject?.acceptType);
  }

  private buildDataModel(): any {
    return {
      complexReturnType: this.getFieldValue('complexReturnType'),
      complexReturnTypeMap: this.getFieldValue('complexReturnType'),
      returnType: this.getFieldValue('returnType'),
      acceptType: this.getFieldValue('acceptType'),
      schemaId: this.getFieldValue('schemaId'),
      schemaIdCom: this.getFieldValue('schemaId'),
    };
  }

  private getFieldValue(fieldName: string): any {
    return this.returnTypeObject?.[fieldName] ?? this.operationData?.[fieldName];
  }

  private openReturnTypeModal(): void {
    this.modalRef = this.modalService.open(FormModalComponent, {
      centered: true,
      backdrop: 'static',
    });
    
    this.getSchemas();
    this.configureModalInstance();
    
    this.modalRef.result.then((result: any) => this.handleModalResult(result));
  }

  private configureModalInstance(): void {
    this.modalRef.componentInstance.fields = addReturnTypeFields;
    this.modalRef.componentInstance.model = this.isEdit ? this.dataModel : {};
    this.modalRef.componentInstance.title = "Add Return Type";
  }

  private handleModalResult(result: any): void {
    const dataObj = this.buildReturnTypePayload(result);
    console.log(dataObj);
    this.submitReturnType(dataObj);
  }

  private buildReturnTypePayload(result: any): any {
    return {
      returnType: result?.returnType,
      acceptType: result?.acceptType,
      complexReturnType: result?.complexReturnType ?? result?.complexReturnTypeMap,
      schemaId: result?.schemaId ?? result?.schemaIdCom,
    };
  }

  private submitReturnType(dataObj: any): void {
    this.restService
      .addReturnType(
        this.projectId,
        this.automationProjectId,
        this.serviceId,
        this.operationId,
        dataObj
      )
      .subscribe({
        next: (item) => this.handleReturnTypeSuccess(dataObj, item),
        error: (error) => this.handleReturnTypeError(error),
      });
  }

  private handleReturnTypeSuccess(dataObj: any, item: any): void {
    this.returnTypeObject = dataObj;
    console.log(item);
    this.toaster.pop({
      type: "success",
      text: MessageEnum.RETURN_TYPE_ADD_SUCCESS,
    });
  }

  private handleReturnTypeError(error: any): void {
    this.isLoading = false;
    this.toaster.pop({
      type: "error",
      text: MessageEnum.RETURN_TYPE_ADD_FAILURE,
    });
  }

  getOperation() {
    this.isLoading = true;
    this.restService
      .getServiceOperationById(
        this.projectId,
        this.automationProjectId,
        this.serviceId,
        this.operationId
      )
      .subscribe({
        next: (item) => {
          this.isLoading = false;
          this.operationData = item?.data;
          this.projectService.setOperation(this.operationData);
        },
        error: (error) => {
          this.isLoading = false;
          console.error("Error fetching service operation data:", error);
        },
      });
  }
}
